import React, {FC, MouseEvent} from 'react';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Typography from '@material-ui/core/Typography';
import {ListItemProps, withStyles} from '@material-ui/core';
import {withLocalization} from 'epic-localization/src/context/LocalizationContext';
import {getTimeRange, getTimeRangeLabel} from './utils';
import {getDirectionStyles} from '../../utils/ThemeUtils';
import ChevronRight from '@material-ui/icons/ChevronRight';

import {TimeRange, TimeScale} from '../../types';

const StyledListItem = withStyles<string, undefined, ListItemProps>(theme => ({
    root: {
        display: 'flex',
        justifyContent: 'space-between',
        color: theme.palette.text.secondary,

        '&:active': {
            color: theme.palette.text.primary
        },
        '&.Mui-selected': {
            color: theme.palette.text.primary
        },

        // Open calendar icon
        '& svg': {
            fontSize: '1.2rem',
            transform: getDirectionStyles(theme.direction)('none', 'rotate(180deg)')
        }
    }
}))(ListItem);

export interface DiscretRangePickerProps {
    value: TimeRange;
    category: TimeScale;
    getMessage: (code: string, args?: any[]) => string;
    onChange: (event: MouseEvent<HTMLDivElement>, value: TimeRange) => void;
}

const DiscretRangePicker: FC<DiscretRangePickerProps> = ({
    value,
    category,
    onChange,
    getMessage
}: DiscretRangePickerProps) => {
    const {timeRanges, defaultTimeRange} = getTimeRange(category);

    const timeRangeOptions = timeRanges.map(timeRange => ({
        label: getTimeRangeLabel({category, timeRange, defaultTimeRange, getMessage}),
        value: timeRange
    }));

    return (
        <List component="div">
            {timeRangeOptions.map(({label, value: optionValue}) => (
                <StyledListItem
                    button
                    key={label}
                    selected={value === optionValue}
                    onClick={event => onChange(event, optionValue)}>
                    <Typography variant="body1">{label}</Typography>
                    {optionValue === TimeRange.TIME_RANGE && <ChevronRight />}
                </StyledListItem>
            ))}
        </List>
    );
};

export default withLocalization(DiscretRangePicker);
